// extracted by mini-css-extract-plugin
module.exports = {"CardProgress":"CardProgress_CardProgress__3_puB"};